import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import "./dropdownItem.scss";
import { tick } from "../../assets/images/icons";
import { createRedirectURL } from "../../utils/helperFunctions";
import { isMobile } from "../../bridges/BridgeServices";

const {
  CLASSES: { MODIFY_ELEMENT },
} = require("../../utils/constants");

const DropdownItem = ({
  uri = "",
  allPagesData = {},
  activeItem = false,
}) => {
  const { title = "" } = allPagesData[uri] || {};

  return (
    <Link to={createRedirectURL(uri)}>
      <li
        className={
          "list-item " +
          (activeItem ? "active-list-item" : "")
        }
      >
        <div className="list-item-div">{title}</div>
        <div
          className={
            "list-item-span " +
            (activeItem ? "" : MODIFY_ELEMENT.HIDE)
          }
        >
          {parse(tick)}
        </div>
      </li>
    </Link>
  );
};

DropdownItem.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  activeItem: PropTypes.bool,
};
export default DropdownItem;
